import {cn, cva} from 'platform/shared';

import {ReactElement, useEffect, useRef} from 'react';

import {makeElementsUnfocusable, Nullish} from 'shared/web';

interface OffscreenContentProps {
  children: ReactElement | Nullish;
}

const offscreenContentVariants = cva(
  'pointer-events-none fixed left-[-9000px] top-[-9000px] m-[-1px] h-px w-px overflow-hidden opacity-0 [clip:rect(0_0_0_0)]'
);

export function OffscreenContent(props: OffscreenContentProps) {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(
    function makeOffscreenContentUnfocusable() {
      const container = containerRef.current;
      // makeElementsUnfocusable handles null containers and returns a no-op cleanup
      const cleanup = makeElementsUnfocusable(container);
      return cleanup;
    },
    [props.children]
  );

  return (
    <div
      ref={containerRef}
      tabIndex={-1}
      aria-hidden="true"
      className={cn(offscreenContentVariants())}
    >
      {props.children}
    </div>
  );
}
